<template>
  <div class="box6-container">
    <div class="title">
      <h3>信息发布</h3>
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
    <div class="content">
      <div class="box6_con">
        <div class="left_num">
          <div class="num_one">{{itemData.total}}<span>屏幕总数</span></div>
          <div class="num_one">{{itemData.program}}<span>节目单总数</span></div>
        </div>
        <div class="right_video">
          <div v-if="itemData.url" class="video">
            <template  v-if="itemData.type==2">
              <img :src="itemData.url"/>
            </template>
            <template  v-else>
            <video
              :src="itemData.url"
              controls
              loop
              autoplay
              width="100%"
              height="100%"
            ></video>
            </template>
          </div>
          <div class="no_video" v-else>暂无投屏</div>
        </div>
      </div>
      
    </div>
    <div class="bottom">
      <div class="r_block">
        <span></span>
        <em></em>
        <span></span>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'Box6', 
  props: {
    itemData: {
      type: Object,
      required: true,
      default: function () {
        return {
          total: 0,
          program: 0,
          url: []
        }
      }
    }
  },
  data() {
    return {
    }
  },
  methods: {
  }
}
</script>
<style lang='less'>
.box6-container {
  width: 100%;
  height: 100%;
  position: relative;
  .title {
    height:48px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/title_bg.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: relative;
    h3{
      font-size: 20px;
      font-weight: normal;
      color: #fff;
      padding-left: 20px;
      margin:0;
      margin-top:5px;
    }
    .r_block{
      position: absolute;
      right:0;
      bottom:9px;
      display: flex;
      align-items: center;
      span{
        width:3px;
        height:7px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:12px;
        height:7px;
        background: #01162b;
        display: block;
      }
    }
  }
  .bottom{
    height:4px;
    display: flex;
    align-items: center;
    justify-content: flex-start ;
    width: 100%;
    background-image: url(../../assets/home_images/con_bot.png);
    background-position: 0 center;
    background-repeat: no-repeat;
    position: absolute;
    bottom: 0;
    left: 0;
    .r_block{
      position: absolute;
      right:0;
      bottom:0px;
      display: flex;
      align-items: center;
      span{
        width:4px;
        height:4px;
        background: #1de7ff;
        display: block;
      }
      em{
        width:10px;
        height:4px;
        background: #01162b;
        display: block;
      }
    }
  }
  .content {
    position: absolute;
    top: 48px;
    bottom: 4px;
    left: 0;
    right:0;
    overflow: hidden;
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    background-image: url(../../assets/home_images/con_left.png);
    background-position: 0 0;
    background-repeat: no-repeat;
    box-sizing: border-box;
    padding: 15px 20px;
  }
}
.box6_con{
  display:flex;
  width:100%;
  height:100%;
  position: relative;
  .left_num{
    height:100%;
    width:125px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    margin-top:-5px;
    .num_one{
      color:#1de7ff;
      font-size: 28px;
      font-family: Bahnschrift, Impact, Haettenschweiler, 'Arial Narrow Bold', sans-serif;
      font-style: normal;
      text-align: center;
      margin-top:10px;
      span{
        margin-top:2px;
        display:block;
        color:#fff;
        font-size: 12px;
      }
    }
  }
  .right_video{
    left:0;
    right:0;
    top:0;
    bottom:0;
    height:100%;
    position: absolute;
    padding-left: 125px;;
    .video{
      width:100%;
      height:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      background: #000;
      overflow: hidden;
      video{
        height:100%;
        width:100%;
        object-fit:fill
      }
      img{
        height:100%;
        width:auto;
      }
    }
    .no_video{
      height:100%;
      width:100%;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size:18px;
      color:#fff;
      background: #3f3a32;
    }
  }
}
</style>
